import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';
import {
  ComWixEcomMembershipsSpiV1HostMembership,
  ComWixEcommerceCatalogSpiApiV1PaymentOptionType,
  MultiCurrencyPriceFragment,
} from '../../../../gql/graphql';
import {PriceModel} from '../Price.model';
import {ModelContext} from '../../../../types/checkoutApp.types';
import {SelectedMembershipModel} from './SelectedMembership.model';

export class PaymentConfigModel {
  public savePaymentMethod?: boolean;
  public consentRequiredPaymentPolicy?: string;
  public depositAmount: PriceModel;
  public paymentOption: PaymentOptionType;
  public selectedMembership?: SelectedMembershipModel;

  constructor(params: PaymentConfigModel) {
    this.savePaymentMethod = params.savePaymentMethod;
    this.consentRequiredPaymentPolicy = params.consentRequiredPaymentPolicy;
    this.depositAmount = params.depositAmount;
    this.paymentOption = params.paymentOption;
    this.selectedMembership = params.selectedMembership;
  }

  public static fromCheckoutV1({
    savePaymentMethod,
    consentRequiredPaymentPolicy,
    paymentOption,
    depositAmount,
    selectedMembership,
    modelContext,
  }: {
    savePaymentMethod?: boolean | null;
    consentRequiredPaymentPolicy?: string | null;
    paymentOption?: ComWixEcommerceCatalogSpiApiV1PaymentOptionType | null;
    depositAmount?: MultiCurrencyPriceFragment | null;
    selectedMembership?: ComWixEcomMembershipsSpiV1HostMembership;
    modelContext: ModelContext;
  }) {
    return new PaymentConfigModel({
      savePaymentMethod: mapNullToUndefined(savePaymentMethod),
      consentRequiredPaymentPolicy: mapNullToUndefined(consentRequiredPaymentPolicy),
      paymentOption: paymentOptionMap[paymentOption!],
      depositAmount: PriceModel.fromCheckoutV1(depositAmount, modelContext),
      selectedMembership: SelectedMembershipModel.fromCheckoutV1(selectedMembership),
    });
  }
}

export enum PaymentOptionType {
  DEPOSIT_ONLINE = 'DEPOSIT_ONLINE',
  FULL_PAYMENT_OFFLINE = 'FULL_PAYMENT_OFFLINE',
  FULL_PAYMENT_ONLINE = 'FULL_PAYMENT_ONLINE',
  MEMBERSHIP = 'MEMBERSHIP',
  MEMBERSHIP_OFFLINE = 'MEMBERSHIP_OFFLINE',
  MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER = 'MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER',
}

const paymentOptionMap: Record<ComWixEcommerceCatalogSpiApiV1PaymentOptionType, PaymentOptionType> = {
  [ComWixEcommerceCatalogSpiApiV1PaymentOptionType.DEPOSIT_ONLINE]: PaymentOptionType.DEPOSIT_ONLINE,
  [ComWixEcommerceCatalogSpiApiV1PaymentOptionType.FULL_PAYMENT_OFFLINE]: PaymentOptionType.FULL_PAYMENT_OFFLINE,
  [ComWixEcommerceCatalogSpiApiV1PaymentOptionType.FULL_PAYMENT_ONLINE]: PaymentOptionType.FULL_PAYMENT_ONLINE,
  [ComWixEcommerceCatalogSpiApiV1PaymentOptionType.MEMBERSHIP]: PaymentOptionType.MEMBERSHIP,
  [ComWixEcommerceCatalogSpiApiV1PaymentOptionType.MEMBERSHIP_OFFLINE]: PaymentOptionType.MEMBERSHIP_OFFLINE,
  [ComWixEcommerceCatalogSpiApiV1PaymentOptionType.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER]:
    PaymentOptionType.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER,
};
